export const data = {
  "id": 48,
  "title": {
    "rendered": "drinks"
  },
  "menu_order": 0,
  "acf": {
    "is_drinks_menu": true,
    "sections": [
      {
        "section_title": "coffee & tea",
        "items": [
          {
            "item_title": "bottomless coffee",
            "item_description": "",
            "item_price_1": "2.75",
            "item_price_2": "",
            "item_price_3": "",
            "item_addons": [],
            "item_uuid": "1531247162456",
            "item_isSpecial": false
          },
          {
            "item_title": "to-go coffee",
            "item_description": "",
            "item_price_1": "2",
            "item_price_2": "2.5",
            "item_price_3": "",
            "item_addons": [],
            "item_uuid": "1531247165423",
            "item_isSpecial": false
          },
          {
            "item_title": "cold brew iced coffee",
            "item_description": "",
            "item_price_1": "2.5",
            "item_price_2": "3",
            "item_price_3": "",
            "item_addons": [],
            "item_uuid": "153124716754361",
            "item_isSpecial": false
          },
          {
            "item_title": "iced tea",
            "item_description": "",
            "item_price_1": "2.5",
            "item_price_2": "",
            "item_price_3": "",
            "item_addons": [],
            "item_uuid": "15312471646789",
            "item_isSpecial": false
          },
          {
            "item_title": "house chai (iced or hot)",
            "item_description": "",
            "item_price_1": "3",
            "item_price_2": "3.5",
            "item_price_3": "",
            "item_addons": [],
            "item_uuid": "15311233246789",
            "item_isSpecial": false
          },
          {
            "item_title": "espresso shot",
            "item_description": "",
            "item_price_1": "2.75",
            "item_price_2": "",
            "item_price_3": "",
            "item_addons": [],
            "item_uuid": "153124716171345",
            "item_isSpecial": false
          },
          {
            "item_title": "latte",
            "item_uuid": 1532473674392,
            "item_price_1": "3.75",
            "item_description": "",
            "item_addons": []
          },
          {
            "item_title": "cappuccino",
            "item_uuid": 1532473690446,
            "item_price_1": "2",
            "item_description": "",
            "item_addons": []
          },
          {
            "item_title": "americano",
            "item_uuid": 1532473691000,
            "item_price_1": "2",
            "item_description": "",
            "item_addons": []
          },
          {
            "item_title": "macchiato",
            "item_uuid": 1532473691663,
            "item_price_1": "2",
            "item_description": "",
            "item_addons": []
          }
        ],
        "section_uuid": "1530244123506",
        "section_isRecurring": true,
        "section_notes": "",
        "section_columns": false
      },
      {
        "section_title": "house-made juices",
        "items": [
          {
            "item_title": "abc",
            "item_description": "apple, carrot, beet, lemon",
            "item_price_1": "6.5",
            "item_price_2": "",
            "item_price_3": "",
            "item_addons": [],
            "item_uuid": "1531247162456",
            "item_isSpecial": false
          },
          {
            "item_title": "popeye",
            "item_description": "spinach, lemon, kale, apple",
            "item_price_1": "7",
            "item_price_2": "",
            "item_price_3": "",
            "item_addons": [],
            "item_uuid": "1531247165423",
            "item_isSpecial": false
          },
          {
            "item_title": "green drink",
            "item_description": "apple, fennel, kale, cucumber, celery",
            "item_price_1": "7",
            "item_price_2": "",
            "item_price_3": "",
            "item_addons": [],
            "item_uuid": "153124716754361",
            "item_isSpecial": false
          },
          {
            "item_title": "sweet tart",
            "item_description": "apple, lemon, cucumber, organge, fennel",
            "item_price_1": "6.5",
            "item_price_2": "",
            "item_price_3": "",
            "item_addons": [],
            "item_uuid": "153124716171345",
            "item_isSpecial": false
          },
          {
            "item_title": "the cleanser",
            "item_uuid": 1532473731361,
            "item_price_1": 7,
            "item_description": "beet, fennel, cucumber, lemon, celery",
            "item_addons": []
          },
          {
            "item_title": "immune booster",
            "item_uuid": 1532473746292,
            "item_price_1": "7",
            "item_description": "orange, grapefruit, fennel, apple with grapefruit seed extract",
            "item_addons": []
          }
        ],
        "section_uuid": "1531247160610",
        "section_isRecurring": false,
        "section_notes": "",
        "section_columns": false
      }
    ],
    "last_save_timestamp": "1532039827"
  }
}


// WEBPACK FOOTER //
// ./src/components/testDrinksMenu.js